import { QueryTuple, useLazyQuery } from '@apollo/client';
import { ProjectConfig } from '@bechtel/types';
import { GET_PROJECT_MILESTONE_LIST } from '@bechtel/client-gql';

export function useProjectMilestoneType(
  projectId: string,
  fetchFromNetwork?: boolean
): QueryTuple<{ projectConfigById: ProjectConfig }, Record<string, any>> {
  const vars = { variables: { id: projectId } };
  const response = useLazyQuery<{
    projectConfigById: ProjectConfig;
  }>(
    GET_PROJECT_MILESTONE_LIST,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
          ...vars,
        }
      : {
          notifyOnNetworkStatusChange: true,
          ...vars,
        }
  );
  return response;
}
